import { RSAA } from 'redux-api-middleware';
import customFailure from 'helpers/customFailureAction';
import { Dispatch } from 'redux';
import { TDispatchResult, TGetRootState } from 'types/shared';
import { IFAQItem } from 'components/FAQ/shared/shared';

export const GET_FAQ_REQUEST = 'opus/faq/GET_FAQ_REQUEST';
export const GET_FAQ_SUCCESS = 'opus/faq/GET_FAQ_SUCCESS';
export const GET_FAQ_FAILURE = 'opus/faq/GET_FAQ_FAILURE';

export const SET_FAQ_REQUEST = 'opus/faq/SET_FAQ_REQUEST';
export const SET_FAQ_SUCCESS = 'opus/faq/SET_FAQ_SUCCESS';
export const SET_FAQ_FAILURE = 'opus/faq/SET_FAQ_FAILURE';

const endpoint = '/kv/faq';

type FAQActionTypes =
  | typeof GET_FAQ_REQUEST
  | typeof GET_FAQ_SUCCESS
  | typeof GET_FAQ_FAILURE
  | typeof SET_FAQ_REQUEST
  | typeof SET_FAQ_SUCCESS
  | typeof SET_FAQ_FAILURE;

interface IFaqAction {
  type: FAQActionTypes;
  payload: any;
}

export interface IFaqState {
  loading: boolean;
  success: boolean;
  error: Error | null;
  errorInfo: any;
  data: IFAQItem[] | null;
}

export const initialState = {
  loading: false,
  success: false,
  error: null,
  errorInfo: null,
  data: null,
};

export default function reducer(
  state: IFaqState = initialState,
  action: IFaqAction
): IFaqState {
  switch (action.type) {
    case GET_FAQ_REQUEST:
    case SET_FAQ_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
        errorInfo: null,
      };

    case GET_FAQ_SUCCESS:
    case SET_FAQ_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: null,
        errorInfo: null,
        data: action.payload,
      };

    case GET_FAQ_FAILURE:
    case SET_FAQ_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: new Error(action.payload.error),
        errorInfo: action.payload.errorInfo,
      };

    default:
      return state;
  }
}

/**
 * Retrieve the selected message from the API and saves it to the store.
 */
export function loadFaq(): any {
  return {
    [RSAA]: {
      types: [
        GET_FAQ_REQUEST,
        GET_FAQ_SUCCESS,
        {
          type: GET_FAQ_FAILURE,
          payload: async (
            action: IFaqAction,
            state: IFaqState,
            res: any
          ): Promise<any> => await customFailure(res),
        },
      ],
      endpoint,
      method: 'GET',
      credentials: 'same-origin',
    },
  };
}

export function shouldLoadFaq(): TDispatchResult<boolean> {
  return (dispatch: Dispatch, getState: TGetRootState): boolean => {
    const {
      faq: { loading, success },
    } = getState();
    return !loading && !success;
  };
}

/**
 * Sends the selected message to the API and saves it to the store.
 */
export const setFaq = (data: any): any => {
  const endpoint = '/kv/faq';

  return {
    [RSAA]: {
      types: [
        SET_FAQ_REQUEST,
        {
          type: SET_FAQ_SUCCESS,
          payload: (): any => data,
        },
        {
          type: SET_FAQ_FAILURE,
          payload: async (
            action: IFaqAction,
            state: IFaqState,
            res: any
          ): Promise<any> => await customFailure(res),
        },
      ],
      endpoint,
      method: 'PUT',
      body: JSON.stringify(data),
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
    },
  };
};
